<script setup>
    /**
     * Vue Scripts
     */
    import {ref} from "vue";

    /**
     * Vue Components
     *
     * @link https://github.com/peshanghiwa/vue-awesome-paginate
     */
    import {VueAwesomePaginate} from "vue-awesome-paginate";
    import "vue-awesome-paginate/dist/style.css";

    const props = defineProps(
        {
            maxPages: Number,
            nextPage: String,
            page: Number,
            perPage: Number,
            prevPage: String,
        }
    )

    const emit = defineEmits(
        [
            'paginationHandler'
        ]
    )

    const currentPage = ref(props.page || 1)
</script>

<template>
    <div class="number-pagination">
        <VueAwesomePaginate
            v-model="currentPage"

            :hidePrevNextWhenEnds="true"
            :items-per-page="perPage"
            :maxPagesShown="3"
            :total-items="maxPages"

            activePageClass="current"
            backButtonClass="page-prev page-arrow"
            disabledPaginateButtonClass="disabled"
            nextButtonClass="page-next page-arrow"
            numberButtonsClass="page-numbers"

            @click="emit('paginationHandler', currentPage)"
        >
            <template #prev-button>
                <span
                    class="text"
                    v-html="prevPage"
                />
                <span class="arrow" />
            </template>

            <template #next-button>
                <span
                    class="text"
                    v-html="nextPage"
                />
                <span class="arrow" />
            </template>
        </VueAwesomePaginate>
    </div>
</template>

<script>
    export default {
        name: "Pagination Component"
    }
</script>

<style scoped lang="scss">
    .pagination-container {
        display: flex;
        column-gap: 10px;
    }

    .paginate-buttons {
        height: 40px;
        width: 40px;
        border-radius: 20px;
        cursor: pointer;
        background-color: rgb(242, 242, 242);
        border: 1px solid rgb(217, 217, 217);
        color: black;
    }

    .paginate-buttons:hover {
        background-color: #d8d8d8;
    }

    .active-page {
        background-color: #3498db;
        border: 1px solid #3498db;
        color: white;
    }

    .active-page:hover {
        background-color: #2988c8;
    }
</style>
